export enum ContractDocumentDeletionBlockerType {
    Obligation = 1,
}

export const contractDocumentBlockerTranslationKeys: Record<ContractDocumentDeletionBlockerType, string> = {
    [ContractDocumentDeletionBlockerType.Obligation]: "obligations",
};
